module.exports = [{
      plugin: require('C:/TeamCity/buildAgent/work/3174b0b60179b3b/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-96783376-2","head":false,"anonymize":true,"respectDNT":true},
    },{
      plugin: require('C:/TeamCity/buildAgent/work/3174b0b60179b3b/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
